// extracted by mini-css-extract-plugin
module.exports = {"arrow_prev":"arrow_prev-5pncB","arrow_next":"arrow_next-qX47e"};